import React from 'react'

function Footer() {
  return (
    <div className="footer">
      <div className="inner">
        <div className="info">
          <p>
            <span className='eksys_sub'>㈜이케이시스</span>
            대표 : 김경열<br />
            주소 : 서울특별시 강남구 테헤란로113길 7 백암아트센타 별관내 4층<br />
            <a className="tel" href='tel:025561764 '>TEL: (02) 556-1764 </a><br />
            <a className="tel" href='fax:025561735 '>FAX: (02) 556-1735 </a><br />
            {/* <a className="mail" href="mailto:SalesMarketing@eksys.co.kr">영업관련 : SalesMarketing@eksys.co.kr </a><br />
            <a className="mail" href="mailto:Technical@eksys.co.kr">기술관련 : Technical@eksys.co.kr </a><br /> */}
            <a className="mail" href="mailto:biz@eksys.co.kr">MAIL: biz@eksys.co.kr </a><br />
            <a href='https://master.wisevcs.co.kr:52001/private/private03.html' target='_blank' className='privacy_policy_span'>개인정보처리방침</a>
          </p>
          <p className="copy">Copyright © eksys 2006. All rights reserved</p>
        </div>
        <div className="right_col">
          {/* <Link to="">
                      <img className="w" src="/assets/images/ft_logo_img01.jpg" alt="" />
                      <img className="m" src="/assets/images/ft_logo_img01.jpg" alt="" />
                  </Link>
                  <Link to="">
                      <img className="w" src="/assets/images/ft_logo_img02.png" alt="" />
                      <img className="m" src="/assets/images/ft_logo_img02.png" alt="" />
                  </Link>
                  <Link to="">
                      <img className="w" src="/assets/images/ft_logo_img03.png" alt="" />
                      <img className="m" src="/assets/images/ft_logo_img03.png" alt="" />
                  </Link> */}
        </div>
      </div>
    </div>
  );
}

export default Footer
